<template>
  <div class="nav-wrap" :class="{ top: isTop }">
    <div class="nav">
      <div
        v-for="item in topBtnList"
        :key="item.type"
        class="top-btn pointer"
        :id="item.id"
      >
        <div class="btn" @click="onBtn(item.type)">
          <img
            class="userImg icon"
            v-if="item.type === 1"
            :src="$store.state.user.headPhoto || defaultImg"
            alt="用户头像"
          />
          <img v-else class="icon" :src="item.icon" alt="icon" />
          <div>{{ item.label }}</div>
          <!-- 购物车数量 -->
          <div
            class="cart-count"
            v-if="item.type === 2 && !!+shoppingCartCount"
          >
            {{ shoppingCartCount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import icon6 from '@/assets/img/main/nav/icon-6.png'
import icon8 from '@/assets/img/main/nav/icon-8.png'
import icon13 from '@/assets/img/main/nav/icon-13.png'
import icon10 from '@/assets/img/main/nav/icon-10.png'
import icon12 from '@/assets/img/main/nav/icon-12.png'
import icon16 from '@/assets/img/main/nav/icon-14.png'
import defaultImg from '@/assets/img/icon.jpg'
import { getAccessToken } from '@/utils/userInfo'

export default {
  props: {
    isTop: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      defaultImg,
      appImg: require('@/assets/img/appDownload.png'),
      topBtnList: [
        { label: '我的', icon: defaultImg, type: 1 },
        { label: '购物车', icon: icon6, type: 2, id: 'add_cart_nav' },
        { label: '专属客服', icon: icon13, type: 9 },
        { label: '询价单', icon: icon12, type: 12 },
        { label: '浏览历史', icon: icon16, type: 16 },
        { label: 'APP', icon: icon8, type: 8 },
        { label: '回到顶部', icon: icon10, type: 10 }
      ],
      shoppingCartCount: 0
    }
  },
  created () {
    this.getCartCount()
  },
  watch: {
    '$store.state.shoppingCartCount': function () {
      this.getCartCount()
    }
  },
  methods: {
    getCartCount () {
      if (getAccessToken() === '' || getAccessToken() === undefined) {
        return false
      }
      this.$request
        .get(`/front/consumer/shoppingcart/queryShoppingCartList`)
        .then((_data) => {
          if (!_data) {
            return
          }
          this.shoppingCartCount = _data.ordinaryCount
        })
    },
    onBtn (type) {
      switch (type) {
        case 1:
          this.$router.push({
            name: 'basicInfo'
          })
          break
        case 2:
          // 判断是否是企业站用户
          if (this.$store.state.user.corpUserInfo.customerId) {
            this.$router.push({
              name: "corpWebsite-myShopCart",
            });
          } else {
            this.$router.push({
              name: "myShopCart",
            });
          }
          break
        case 8:
          this.openAPP()
          break
        case 9:
          this.$consultJump(this.$store.state.user)
          break
        case 10:
          this.jumpTop('main-content')
          break
        case 12:
          this.$router.push({
            path: '/personalCenter/inquiryList'
          })
          break
        case 16:
          // 判断是否是企业站用户
          if (this.$store.state.user.corpUserInfo.customerId) {
            this.$router.push({
              name: "corpWebsite-browseHistory",
            });
          } else {
            this.$router.push({
              name: "browseHistory",
            });
          }
          break
      }
    },
    jumpTop (domId) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth' // 可选，平滑滚动效果
      })
    },
    openAPP () {
      this.$alert(
        `<div style="text-align:center;"><img src="${this.appImg}" style="width:100px;" /></div>`,
        '扫码下载APP',
        {
          dangerouslyUseHTMLString: true
        }
      ).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-wrap {
  position: absolute;
  width: 1200px;
  position: sticky;
  top: 50vh;
  pointer-events: none;

  &.top {
    top: 0;
    transform: translateY(50px);

    .nav {
      top: 0;
      transform: none;
    }
  }
}

.nav {
  min-width: 48px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 999;
  position: absolute;
  left: calc(100% + 28px);
  top: 0;
  transform: translateY(-50%);
  pointer-events: auto;
  border-radius: 16px;
  background: #ffffff;
  padding: 8px 12px;
  box-sizing: content-box;

  &::-webkit-scrollbar {
    display: none;
    /*隐藏滚动条*/
  }

  .top-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Alibaba PuHuiTi;
    font-size: 12px;
    font-weight: 400;
    line-height: 16.46px;
    text-align: center;
    color: #5e6066;
    margin: 8px 0;

    .userImg {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 1px solid #fff;
    }
    .icon {
      margin: 0 0 4px;
    }
  }
  .pointer:hover {
    opacity: 0.8;
  }
  .btn {
    position: relative;
    .cart-count {
      position: absolute;
      right: 5px;
      top: 1px;
      border-radius: 8px;
      background: #e93037;
      font-size: 12px;
      font-weight: bold;
      color: #fff;
      text-align: center;
      line-height: 16px;
      padding: 0 4px;
      box-shadow: 0px 2px 4px 0px #e9303766;
    }
  }
}
</style>
